<template>
  <div>
    <Card v-show="!isShow">
      <p slot="title">提成系统</p>
      <!-- <project :count="QRcount" imageUrl="/img/icons/ticheng/1.png" title="19年3月1日之后提成上报（含线上）" @click.native="declare('QR')"></project>
      <project :count="FQCount" imageUrl="/img/icons/ticheng/2.png" title="19年3月1日之前提成上报（仅线下）" @click.native="declare('FQ')"></project>
      <project :count="FPCount" imageUrl="/img/icons/ticheng/3.png" title="提成发放申报" @click.native="declare('FP')"></project> -->
      <!-- <div style="width:200px;position:absolute;right:0;top:52px">
        <Collapse accordion v-model="accordion">
          <Panel name="提成规则">
            提成规则
            <ul slot="content">
              <li @click="selectionModal=true;title='分公司奖金规则申报表'">奖金规则申报表 <Icon type="ios-arrow-forward"></Icon></li>
              <li @click="selectionModal=true;title='分公司奖金剩余部分分配规则申报表'">剩余奖金规则申报表 <Icon type="ios-arrow-forward"></Icon></li>
              <li @click="selectionModal=true;title='业务员月度任务申报表'">业务员月度任务申报表 <Icon type="ios-arrow-forward"></Icon></li>
            </ul>
          </Panel>
        </Collapse>
      </div> -->
      <Row type="flex" align="middle" style="width:fit-content;margin:0 auto;">
        <Col style="width:130px;margin:0 14px;">
          <project :count="ZJQRCount" imageUrl="/img/icons/ticheng/6.png" title="21年湛江提成" @click.native="declare('ZJQR')"></project>
          <project :count="ZXQRCount" imageUrl="/img/icons/ticheng/6.png" title="21年咨询事业部提成" @click.native="declare('ZXQR')"></project>
          <!-- <project imageUrl="/img/icons/ticheng/4.png" title="分公司奖金规则申报表" @click.native="showReport('分公司奖金规则申报表')"></project>
          <Row style="height:30px;"></Row>
          <project imageUrl="/img/icons/ticheng/5.png" title="分公司奖金剩余部分分配规则申报表" @click.native="showReport('分公司奖金剩余部分分配规则申报表')"></project>
          <Row style="height:30px;"></Row>
          <project imageUrl="/img/icons/ticheng/6.png" title="业务员月度任务申报表" @click.native="showReport('业务员月度任务申报表')"></project> -->
        </Col>
        <!-- <Col style="margin: 0 14px">
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
        </Col> -->
        <Col style="width:130px;margin:0 14px;">
          <project :count="QRCount" imageUrl="/img/icons/ticheng/1.png" title="19年3月1日之后提成上报（含线上）" @click.native="declare('QR')"></project>
          <Row style="height:30px;"></Row>
          <project :count="FQCount" imageUrl="/img/icons/ticheng/2.png" title="19年3月1日之前提成上报（仅线下）" @click.native="declare('FQ')"></project>
        </Col>
        <Col style="margin: 0 14px">
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
          <Icon type="chevron-right" size="20"></Icon>
        </Col>
        <Col style="width:130px;margin:0 14px;">
          <project :count="FPCount" imageUrl="/img/icons/ticheng/3.png" title="提成发放申报" @click.native="declare('FP')"></project>
        </Col>
        <!-- <Col style="width:130px;margin:0 14px;">
          <project imageUrl="/img/icons/ticheng/7.png" title="季度统计报表" @click.native="showReport('季度统计报表')"></project>
          <Row style="height:30px;"></Row>
          <project imageUrl="/img/icons/ticheng/8.png" title="统计报表（领导）" @click.native="showReport('统计报表（领导）')"></project>
          <Row style="height:30px;"></Row>
          <project imageUrl="/img/icons/ticheng/9.png" title="累计销售额前三名" @click.native="showReport('累计销售额前三名')"></project>
        </Col> -->
        <Col style="width:200px" class-name="accordion">
          <Collapse accordion v-model="accordion">
            <Panel name="提成规则">
              提成规则
              <ul slot="content">
                <li @click="selectionModal=true;title='分公司奖金规则申报表'">奖金规则申报表 <Icon type="ios-arrow-forward"></Icon></li>
                <li @click="selectionModal=true;title='分公司奖金剩余部分分配规则申报表'">剩余奖金规则申报表 <Icon type="ios-arrow-forward"></Icon></li>
                <li @click="selectionModal=true;title='业务员月度任务申报表'">业务员月度任务申报表 <Icon type="ios-arrow-forward"></Icon></li>
              </ul>
            </Panel>
            <!-- <Panel name="2">
              统计分析
              <Button icon="share"></Button>
              <ul slot="content">
                <li><Icon type="stats-bars"></Icon> 进销存变动</li>
                <li><Icon type="stats-bars"></Icon> 进销存分析</li>
                <li><Icon type="stats-bars"></Icon> 合同多维分析</li>
                <li><Icon type="stats-bars"></Icon> 部门结算收入汇总表（领导）</li>
              </ul>
            </Panel>
            <Panel name="3">
              业务预警
              <Button icon="share"></Button>
              <ul slot="content">
                <li><Icon type="stats-bars"></Icon> 进销存变动</li>
                <li><Icon type="stats-bars"></Icon> 进销存分析</li>
                <li><Icon type="stats-bars"></Icon> 合同多维分析</li>
                <li><Icon type="stats-bars"></Icon> 部门结算收入汇总表（领导）</li>
              </ul>
            </Panel> -->
          </Collapse>
        </Col>
      </Row>
    </Card>
    <!-- 地区 分公司选择窗口 -->
    <Modal
      width="500"
      v-model="selectionModal"
      title="地区/分公司">
      <p style="margin: 10px 0">请选择地区：</p>
      <RadioGroup v-model="flowDetail.area" @on-change="getCompany">
        <Radio :label="item.name" v-for="item in area" :key="item.name" style="width: 114px;margin:4px 0"></Radio>
      </RadioGroup>
      <p style="margin: 10px 0">请选择分公司：</p>
      <RadioGroup v-model="flowDetail.company">
        <Radio :label="item.cName" v-for="item in company" :key="item.id" style="margin:4px 0"></Radio>
      </RadioGroup>
      <div slot="footer">
        <Button @click="selectionModal=false">取消</Button>
        <Button type="primary" @click="showReport(title)">查看</Button>
      </div>
    </Modal>
    <Modal
      width="98%"
      height="95%"
      v-model="report"
      :title="title">
      <iframe style="width:100%;height:700px;border:0;" :src="functionUrl"></iframe>
      <div slot="footer"></div>
    </Modal>
    <Modal v-model="fillDetailVisible" :title="declareReportTitle" width="98%" :mask-closable="false">
      <div v-if="fillTableType==='rule'">
        <commissionRuleDetail :flowDetail="flowDetail"></commissionRuleDetail>
      </div>
      <div v-if="fillTableType==='task'">
        <commissionTaskDetail :flowDetail="flowDetail"></commissionTaskDetail>
      </div>
      <div slot="footer">
        <Button @click="fillDetailVisible=false">关闭</Button>
      </div>
    </Modal>
    <component 
      :is="view" 
      v-show="isShow" 
      @return="(val)=>{isShow=val}" 
      :type="flowType"></component>
  </div>
</template>

<script>
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import declare from './declare'
import project from './project'
import CommissionRuleDetail from '@/components/flow/extraInfo/commissionDetail/commissionRuleDetail'
import CommissionTaskDetail from '@/components/flow/extraInfo/commissionDetail/commissionTaskDetail'
import { formatDate } from '@/lib/tool'

export default {
  components: {
    declare,
    project,
    CommissionRuleDetail,
    CommissionTaskDetail,
  },
  data() {
    return {
      view: 'declare',
      isShow: false,
      flowType: 'QR',
      accordion: '',
      title: '报表标题',
      report:false,
      functionUrl: '',
      fillTableType: 'rule',
      fillDetailVisible: false,
      declareReportTitle: '',
      selectionModal: false,
      area: [],
      company: [],
      flowDetail: {
        area: '地区',
        company: '采联',
        time: "2020-01-01"
      },
    };
  },
  computed: {
    QRCount() {
      return this.$store.state.todoCount.QRCount || 0
    },
    ZJQRCount() {
      return this.$store.state.todoCount.ZJQRCount || 0
    },
    ZXQRCount() {
      return this.$store.state.todoCount.ZXQRCount || 0
    },
    FQCount() {
      return this.$store.state.todoCount.FQCount || 0
    },
    FPCount() {
      return this.$store.state.todoCount.FPCount || 0
    }
  },
  mounted() {
    // 根据角色获取地区
    ajax.get(requestUrls.CLDistrict.GetList).then(res => {
      this.area = res.data.result.items
      this.flowDetail.area = this.area[0].name
      this.getCompany()
    })
  },
  methods: {
    declare(val) {
      // if (val === 'FP') {
      //   let a = this.$store.getters["session/hasRoles"]("WX_CEO")
      //   let b = this.$store.getters["session/hasRoles"]("WX_董事长")
      //   let c = this.$store.getters["session/hasRoles"]("WX_副总裁")
      //   let d = this.$store.getters["session/hasRoles"]("分公司负责人")
      //   let e = this.$store.getters["session/hasRoles"]("总部财务助理")
      //   let f = this.$store.getters["session/hasRoles"]("信息中心")
      //   if (!(a || b || c || d || e || f)) {
      //     this.$Message.info('没有相关权限')
      //     return
      //   }
      // }
      this.flowType = val
      this.isShow = true
    },
    getCompany() {
      // 根据地区获取分公司
      ajax.get(requestUrls.bankAccount.getAll,{
        params: {
          filter: `district=="${this.flowDetail.area}"`
        }
      }).then(res => {
        this.company = res.data.result.items
        if (this.company.length !== 0) {
          // 去重
          const map = new Map()
          this.company = this.company.filter((item) => !map.has(item.cName) && map.set(item.cName,1))
          this.flowDetail.company = this.company[0].cName
        }
      })
    },
    showReport(title) {
      console.log(this.flowDetail)
      if (this.flowDetail.area === '' || this.flowDetail.company === '' || this.flowDetail.time === '') {
        this.$Message.info('请确认时间、地区及分子公司')
        return
      }
      // 报表特殊时间要求传入
      let baseTime = formatDate(this.flowDetail.time)
      let time = baseTime.split(' ')[0].substr(0, 8) + '01'
      let startTime = '2020-03-01'
      let endTime = '2021-02-28'

      if (title === '分公司奖金规则申报表') {
        this.declareReportTitle = '分公司奖金规则申报表'
        this.fillTableType = 'rule'
        this.fillDetailVisible = true
      }
      if (title === '分公司奖金剩余部分分配规则申报表') {
        this.title = '分公司奖金剩余部分分配规则申报表'
        this.functionUrl = `${requestUrls.reportUrl}/WebReport/ReportServer?reportlet=cailian%2F%5B8d22%5D%5B52a1%5D%5B63d0%5D%5B6210%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B63d0%5D%5B6210%5D%5B89c4%5D%5B5219%5D%2F%5B5206%5D%5B516c%5D%5B53f8%5D%5B5269%5D%5B4f59%5D%5B90e8%5D%5B5206%5D%5B5206%5D%5B914d%5D%5B89c4%5D%5B5219%5D.cpt&op=write&branch=${this.flowDetail.area}&childcompany=${this.flowDetail.company}&starttime=${startTime}&endtime=${endTime}`
        this.report = true
      }
      if (title === '业务员月度任务申报表') {
        this.declareReportTitle = '业务员月度任务申报表'
        this.fillTableType = 'task'
        this.fillDetailVisible = true
      }
    },
  }
};
</script>
<style lang="less" scoped>
/deep/ .ivu-modal{
  top: 20px;
}
/deep/.ivu-card-body {
  padding: 30px;
  .accordion {
    position: absolute;
    top: 50px;
    right: 0;
  }
  .ivu-collapse-content,.ivu-collapse-content-box {
    padding: 0;
  }
  .ivu-collapse-header button {
    font-size: 18px;
    padding: 0;
    border: 0;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    &:hover {
      background-color: #f7f7f7;
    }
  }
  ul li {
    list-style: none;
    padding: 6px 10px 6px 30px;
    cursor: pointer;
    &:hover {
      background-color: #f7f7f7;
    }
    & + li {
      border-top: 1px solid #dddee1;
    }
  }
}
</style>
